
import terms from '../Exchange/tc';



 export const pools = [
    {
        type: 'punk',
        id: 0,
        order: 0,
        totalSupply: 27,
        poolName: 'Cryptopunk Pool',
        poolUrl: 'https://larvalabs.com/cryptopunks/accountInfo?account=0x8fa20dcc712bd224b54bc1cdfd30a37349f8df2a#',
        poolInfo: 'CryptoPunks are the ultimate flex NFTs. The most expensive Punk to date sold for more than $7.5 million with some of the rarer ones being sold via Christie’s Auction House. You can get your own Punk simply by exchanging your Dust.',
        tokenInfo: 'You can exchange ***** Dust for a Punk randomly selected from the Punk Pool via Chainlink’s VRF. After exchanging your dust, you will receive a Coupon that shows the ID of the Punk that was selected. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'larvalabs',
        terms: terms,
        congratsText: 'You have successfully reserved your CryptoPunk. To receive it, please contact the Ether Cards team at [exchange@ether.cards](mailto:exchange@ether.cards) with your address that holds this coupon. Shortly after, you will receive an email with further instructions.'
    },
    {
        type: 'meebit',
        id: 1,
        order: 1,
        totalSupply: 30,
        poolName: 'Meebit Pool',
        poolUrl: 'https://meebits.larvalabs.com/meebits/account?address=0x1f3911F4F43671d187A882df129773A7261989e8',
        poolInfo: 'Meebits is another NFT Collection by Larva Labs, the creators of CryptoPunks. These limited edition NFTs are a great alternative to the coveted CryptoPunks. You can own your own Meebit simply by exchanging your Dust via the button below.',
        tokenInfo: 'You can exchange ***** Dust for a Meebit, randomly selected from the Meebit Pool via Chainlink’s VRF. After exchanging your Dust, you will receive the Meebit in your wallet. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'opensea',
        terms: terms,
        congratsText: 'You have successfully claimed the NFT. You can view it by heading to your wallet or go back to the Dust Pools to claim some more.'
    },
    {
        type: 'tyson',
        id: 2,
        order: 6,
        totalSupply: 25,
        poolName: 'Mike Tyson Pool',
        poolUrl: 'https://opensea.io/0xCdA66b3f393cEfc6E476E2183164bD2e9DA78f2e',
        poolInfo: 'World famous boxer Mike Tyson has an exclusive and limited edition collection of just over 500 NFTs. The one-of-one Ultimate NFT features incredible Traits that can fly you to Mike’s ranch for a one-on-one training session and much more. Join this exclusive club simply by exchanging your Dust via the button below.',
        tokenInfo: 'You can exchange ***** Dust for THE BADDEST MAN ON THE PLANET Mike Tyson NFT, randomly selected from the Tyson Pool via Chainlink’s VRF. The 25 held in this pool are the first ever minted, holding ID #1-25. After exchanging your Dust, you will receive the Tyson NFT in your wallet. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'opensea',
        terms: terms,
        congratsText: 'You have successfully claimed the NFT. You can view it by heading to your wallet or go back to the Dust Pools to claim some more.'
    },
    {
        type: 'alpha',
        id: 3,
        order: 2,
        totalSupply: 50,
        poolName: 'EC Alpha Pool',
        poolUrl: 'https://opensea.io/0xA375A68CbFf5226E51eEBc2128493D1e30F171B1',
        poolInfo: 'With only 900 of these NFTs ever in existence, this is an opportunity not to be missed. Every Alpha has two sides of artwork, including a 5-layered accidental collaboration. These NFTs also feature Traits that provide various exciting benefits and bonuses across the entire Ether Cards ecosystem.',
        tokenInfo: 'You can exchange ***** Dust for an Alpha Card, randomly selected from the Alpha Pool via Chainlink’s VRF. After exchanging your Dust, you will receive the Alpha Card in your wallet. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'opensea',
        terms: terms,
        congratsText: 'You have successfully claimed the NFT. You can view it by heading to your wallet or go back to the Dust Pools to claim some more.'
    },
    {
        type: 'founder',
        id: 4,
        order: 3,
        totalSupply: 200,
        poolName: 'EC Founder Pool',
        poolUrl: 'https://opensea.io/0xB27b95e6B138c968ec1BDC56D4a538Ed0F83b3C2',
        poolInfo: 'Founder Cards are the easiest way to become a part of this incredible Ether Cards community. Each card features a 5-layered accidental collaboration, as well as featuring Traits that provide various exciting benefits and bonuses across the entire Ether Cards ecosystem. Become a Founder owner simply by exchanging your Dust via the button below.',
        tokenInfo: 'You can exchange ***** Dust for a Founder Card, randomly selected from the Founder Pool via Chainlink’s VRF. After exchanging your Dust, you will receive the Founder Card in your wallet. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'opensea',
        terms: terms,
        congratsText: 'You have successfully claimed the NFT. You can view it by heading to your wallet or go back to the Dust Pools to claim some more.'
    },
    {
        type: 'metazoo',
        id: 5,
        order: 4,
        totalSupply: 50,
        poolName: 'MetaZoo Pool',
        poolUrl: 'https://opensea.io/0xfa87ae4cf49806eEaEa2F7DF1B7411834Ab097d6',
        poolInfo: 'MetaZoo Games NFTs are the next generation of collectibles, connecting MetaZoo products with NFTs. Gain exclusive and early access before others as you collect all 6 unique tokens which function as the currency in the MetaZoo lore.',
        tokenInfo: 'You can exchange ***** Dust for a Metazoo NFT, randomly selected from the Metazoo Pool via Chainlink’s VRF. After exchanging your Dust, you will receive the Metazoo NFT in your wallet. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'opensea',
        terms: terms,
        congratsText: 'You have successfully claimed a Metazoo NFT. You can view it by heading to your wallet or go back to the Dust Pools to claim another NFT.'
    },
    {
        type: 'toddlerpillars',
        id: 6,
        order: 5,
        totalSupply: 100,
        poolName: 'Toddlerpillars Pool',
        poolUrl: 'https://opensea.io/0x9dFF1113CF4186deC4feb774632356D22f07eB9e',
        poolInfo: 'Toddlerpillars are the NFT collection you’ve been waiting to buy into without even knowing it!. With a record-breaking 888 unique layers, you will be sure to receive an amazing piece. Become a Toddlerpillar owner simply by exchanging your Dust via the button below.',
        tokenInfo: 'You can exchange ***** Dust for a Toddlerpillar NFT, randomly selected from the Toddlerpillar Pool via Chainlink’s VRF. After exchanging your Dust, you will receive the Toddlerpillar NFT in your wallet. Please ensure you follow the entire process to complete the exchange successfully.',
        poolIcon: 'opensea',
        terms: terms,
        congratsText: 'You have successfully claimed a Toddlerpillar NFT. You can view it by heading to your wallet or go back to the Dust Pools to claim another NFT.'
    }

  ];
